import {
    AllEvents,
    ArticleLikePublication,
    isArticleLikeType,
} from '@news-mono/web-common'
import React from 'react'
import {
    InlineContentTypes,
    InlineTNRegisterAccount,
} from '../SharedPublication.routing'
import { TNCreateAccountBanner } from '../../../banners'

export interface getInlinePositionedTNRegisterAccountDriverProps {
    publication: ArticleLikePublication
    inlinePublicationContent: InlineContentTypes[]
    onEvent: (event: AllEvents) => void
}

export function isInlineTNRegisterAccountDriver(
    content: InlineContentTypes,
): content is InlineTNRegisterAccount {
    return content.kind === 'inline-tn-register-account'
}

export function getInlinePositionedTNRegisterAccountDriver({
    publication,
    inlinePublicationContent,
    onEvent,
}: getInlinePositionedTNRegisterAccountDriverProps) {
    if (!isArticleLikeType(publication)) {
        return []
    }

    return inlinePublicationContent
        .filter(isInlineTNRegisterAccountDriver)
        .map((content) => {
            const mappedContent = {
                position: content.insertAfter,
                element: (
                    <TNCreateAccountBanner
                        onEvent={onEvent}
                        heading={publication.heading}
                        feature={'inline-create-account-cta'}
                    />
                ),
            }
            return mappedContent
        })
}
